var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyArtis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6104",
    "data-name": "Group 6104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.57,
    height: 36.039,
    viewBox: "0 0 64.57 36.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 64.57,
    height: 36.039,
    fill: "#c1c1c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6004",
    "data-name": "Group 6004",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6003",
    "data-name": "Group 6003",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M197.733,36.039c-.7-.73-1.389-1.473-2.105-2.189-3.068-3.068-6.145-6.129-9.172-9.146l3.765-3.733,7.488,7.483L226.225,0l4.067,4.047a3.716,3.716,0,0,0-.791.484q-14.508,14.452-29,28.922-1.3,1.293-2.589,2.587Z",
    transform: "translate(-165.722)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M3.794,35.693,0,31.9,30.108,1.924,41.331,13.008,37.6,16.735,30.221,9.324,3.794,35.693",
    transform: "translate(0 -1.71)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M453.9,218.165l-3.575,3.523-6.937-6.952,3.56-3.512,6.952,6.941",
    transform: "translate(-394.078 -187.736)",
    fill: "#c1c1c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyArtis);
export default __webpack_public_path__ + "static/media/company-artis.6894b4d0d0ef1da288cbe86336040c49.svg";
export { ForwardRef as ReactComponent };